/**
 * Replaces <h1> in sanitized UGC with <h2> so pages keep a single page-level <h1>
 * (React shell) and body sections use h2+ (Semrush / heading best practices).
 */
export function demoteH1ToH2InUgcHtml(html: string): string {
  if (!html || typeof html !== 'string') {
    return '';
  }
  return html
    .replace(/<h1(\s|>)/gi, '<h2$1')
    .replace(/<\/h1\s*>/gi, '</h2>');
}
